import Vue from 'vue';

const underscorify = value => {
  if (!value) {
    return '';
  }
  const words = value.split(' ');
  return words.join('_');
};
export default underscorify;

Vue.filter('underscorify', underscorify);
